var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7265_7574",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 0H0V80H80V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7265_7574)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5541 29.0462C69.24 32.9304 70 36.0587 70 40.5765C70 57.9604 56.8142 71.6666 39.715 71.6666C22.6156 71.6666 8.75 57.5755 8.75 40.1916C8.75 22.8077 22.6129 8.71521 39.7135 8.71521C49.9684 8.71521 59.0584 13.7836 64.6936 21.5897L64.6425 21.6039C50.0403 28.8706 38.8416 46.7631 33.7343 59.1699C28.6448 48.0877 19.921 39.0215 19.921 39.0215",
    stroke: "#395966",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4458 17.0556C22.7166 25.7847 22.7166 39.9375 31.4458 48.6666C40.1749 57.3957 54.3276 57.3957 63.0568 48.6666C71.7859 39.9375 71.7859 25.7847 63.0568 17.0556C54.3276 8.32642 40.1749 8.32642 31.4458 17.0556Z",
    fill: "#FFEBC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskSuccess);
export default __webpack_public_path__ + "static/media/taskSuccess.04d84a80b3ff93ca8a5d37f814bc7407.svg";
export { ForwardRef as ReactComponent };